<template>
    <div>
        <div class="md-card-select" style="flex-direction: column; border-bottom: none">
            <div class="rule-form" v-bind:key="rule.id" v-for="rule in rules">
                <div class="cb-group" @click="() => { if (!rule.disabled) updateRule(rule) }">
                    <checkbox :value="rule.checked" :disabled="rule.disabled" :toggle-check="true"/>
                    <labelc type="header" class="wide-label" :text="rule.name"
                            :styleText="{marginLeft: '10px'}"/>
                </div>
                <div class="explain">{{ rule.description }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'rulesgroup',
    props: {
        rules: Array,
    },
    methods: {
        updateRule(rule) {
            rule.checked = !rule.checked;
        },
    }
}
</script>

<style scoped>
.md-card-select {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: left;
    align-items: baseline;
    padding-left: 0px !important;
}

.md-card-select .wide-label {
    width: 400px;
}

.explain {
    width: 100%;
    font-size: 13px;
    color: var(--contrast-4);
}

.rule-form {
    margin: 10px 0 0 10px;
}

.cb-group {
    display: flex;
    height: 20px;
    align-self: center;
}
</style>
